import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {endpoints} from '../../../core/configs/endpoints';

/**
 * Service to interact with the Profile API.
 * Provides methods to retrieve the users profile, loyalty, personal information etc.
 */

export interface RequestSupportResponse {
  result?: {
    status?: 'success' | 'error';
    message?: string;      // messaggio dal backend, se esiste
    request_id?: number;   // o qualsiasi dato ti serva
  };
}

@Injectable({providedIn: 'root'})
export class RequestMaintenanceApiService {
  private readonly _httpClient = inject(HttpClient)

  /**
   * Retrieves the profile of a specific user.
   * @returns An Observable emitting the user's profile.
   */

  public requestSupport(body: { locationId: string; policyId: string }) {
    return this._httpClient.post<RequestSupportResponse>(`${endpoints.request_maintenance.request}`, body);
  }
}
